<template>
    <div>
        <Form :label-width="120" label-position="left">
            <Row :gutter="15">
                <Col :xs="24" :sm="24" :md="12" :lg="6">
                    <FormItem :label="$t('Year')"><!-- 年度 -->
                        <DatePicker type="year" v-model="searchItem.year"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="2">
                <Button @click="total=0,pageInfo.pageNo=1,getData()"><!-- 检 索 -->{{$t('Search')}}</Button>
                </Col>
            </Row>
        </Form>
        <Table border ref="selection" :loading="loading" :columns="columns" :data="data" style="margin-top:20px">
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" icon="md-reorder" size="small" @click="checkBtn(row, index)"></Button>
            </template>
        </Table>
        <div style="margin:20px 0;">
            <Page style="float: right" :total="total" @on-change="pageChange"/>
            <Button @click="returnPage()"><!-- 返回 -->{{$t('Return')}}</Button>
        </div>
    </div>
</template>


<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return {
            date: new DateUtil(),
            loading:false,
            searchItem:{},
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Check'),/* 查看 */
                    slot: "action",
                    align: "center",
                    minWidth:100
                },{
                    title: this.$t('Name'),/* 姓名 */
                    key: "userName",
                    align: "center",
                    minWidth: 120
                },
                {
                    title: this.$t('Employee_Code'),/* 员工号 */
                    key: "empCode",
                    align: "center",
                    minWidth: 200
                },{
                    title: this.$t('Department'),/* 部门 */
                    key: "department",
                    align: "center",
                    minWidth: 200
                },{
                    title: this.$t('Position'),/* 职位 */
                    key: "position",
                    align: "center",
                    minWidth: 200
                },{
                    title: this.$t('BU'),/* 业务单元 */
                    key: "businessUnit",
                    align: "center",
                    minWidth: 200
                },{
                    title: this.$t('Year'),/* 年度 */
                    key: "year",
                    align: "center",
                    minWidth: 100
                },{
                    title: this.$t('Line_Manager'),/* 直线上级 */
                    key: "dirSupUserName",
                    align: "center",
                    minWidth: 200
                }
            ]
        }
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            this.loading=true
            this.searchItem.year=this.date.dateVal(this.searchItem.year,'YYYY')
            axios.post("/achUpdatePlan/selectMyselfAchUpdatePlanInfo", {...this.pageInfo,...this.searchItem}).then((res) => {
                this.loading=false
                if (res) {
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
        checkBtn(row,index){
            this.$router.push({
                path: '/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27',
                query: { isDirSup: row.isDirSup ,id:row.id,item:JSON.stringify(row)}
            })
        },
        returnPage(){
            this.$router.back()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index/components/HomePageAchUpdate.vue